module.exports = __webpack_public_path__ + "static/media/apartment8.b598a83a.jpg";